import React from 'react'
import '../style/home.css';
import { useTranslation } from 'react-i18next';
const Home = () => {
  const {t} = useTranslation();
  return (
    <div className='home'>
      <h1> {t("HEADING.HOMETITLE")} </h1>
    </div>
  )
}

export default Home
